import { useState, useCallback } from "react";

export type TabType = "chat" | "editor" | "left" | "right";

interface UseWorkspaceNavigationProps {
  initialTab?: TabType;
  pollType?: string;
  isTablet?: boolean;
}

export function useWorkspaceNavigation({
  initialTab = "chat",
  pollType = "date",
  isTablet = false,
}: UseWorkspaceNavigationProps = {}) {
  const [mobileActiveTab, setMobileActiveTab] = useState<TabType>(initialTab);
  const [showManualEditorOnMobile, setShowManualEditorOnMobile] = useState(false);

  // Determine if we should show both sides (desktop/tablet split view)
  // Availability and Quizz have custom full-screen behaviors
  const showBothSides = pollType !== "availability" && pollType !== "quizz";

  const toggleMobileTab = useCallback((tab: TabType) => {
    setMobileActiveTab(tab);
  }, []);

  const openManualEditor = useCallback(() => {
    setShowManualEditorOnMobile(true);
    setMobileActiveTab("editor");
  }, []);

  const closeManualEditor = useCallback(() => {
    setShowManualEditorOnMobile(false);
    setMobileActiveTab("chat");
  }, []);

  return {
    mobileActiveTab,
    setMobileActiveTab, // Exposed for direct control if needed
    showManualEditorOnMobile,
    setShowManualEditorOnMobile, // Exposed for direct control if needed
    showBothSides,
    toggleMobileTab,
    openManualEditor,
    closeManualEditor,
  };
}
